import React, { useState, useEffect, useCallback } from "react";
import { BsFillExclamationTriangleFill } from 'react-icons/bs'
import { Link } from 'react-router-dom'
import { BgLoader, InLoader, PageError } from '../../ui'
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { instance } from "../../axios";

export const postRedirect = (url, data = {}) => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = url;
  form.style.display = 'none';

  Object.entries(data).forEach(([key, value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = value ?? '';
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();

  // Optional cleanup
  setTimeout(() => {
    document.body.removeChild(form);
  }, 1000);
};


export default function PayRedirect() {
  let { id } = useParams();

  const [state, setState] = useState([]);

  const fetchData = () => {
    instance
      .get("/cust_pay?id=" + id)
      .then(function (response) {
        setState({ ...state, ...response.data })
        if (response.data.status == 'success' && response.data.url) {
          postRedirect(response.data.url, response.data.attrs)
        }
      })
      .catch(function (error) { })
      .then(function () { });
  }



  useEffect(() => {
    fetchData()
  }, []);

  if (state.status == 'error') {
    return (
      <PageError msg={state.msg} />
    )
  }
  return (
    <div className="text-center mt-5">
      <BgLoader />
    </div>
  );
}
